export const createCache = () => {
    const cache = new Map();
    const get = (key) => {
        return cache.get(key);
    };
    const has = (key) => {
        return cache.has(key);
    };
    const remove = (key) => {
        cache.delete(key);
    };
    const set = (key, value) => {
        cache.set(key, value);
    };
    return {
        get,
        has,
        remove,
        set,
    };
};
//# sourceMappingURL=cache.js.map